// Lib
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'react-router-redux';

import { Sheet } from '../../../mobile/structural/sheet/Sheet';
import useSheet from '../../../mobile/structural/sheet/hooks/useSheet';
import { SheetId } from '../../../mobile/structural/sheet/sheetTypes';
import useSheetScrollExcess from '../../../utils/keyboard/useSheetScrollExcess';
import { RomaAuthSheetContent } from '../RomaAuthModal';

const ROOT_PATH = '/';

export const AuthSheet: React.FC<{ className?: string; close?: (() => void) | null }> = ({ children, close }) => {
    const dispatch = useDispatch();

    const onCloseTransitionEnd = useCallback(() => {
        // When the sheet is opened above a public board (published or editable link), then the
        // close property will be a function that navigates back to the previous location
        close ? close() : dispatch(push(ROOT_PATH));
    }, [close, dispatch]);

    const sheetProps = useSheet(SheetId.Auth, undefined, { openByDefault: true, onCloseTransitionEnd });

    useSheetScrollExcess({
        enabled: sheetProps.isOpen,
        scrollableParentRef: sheetProps.contentRef,
        sheetId: SheetId.Auth,
    });

    return (
        <Sheet {...sheetProps} defaultSnapPoint={1} snapPoints={[1]}>
            <Sheet.Overlay />
            <Sheet.Panel className="AuthSheetContainer AuthModal">
                <Sheet.Content>
                    <RomaAuthSheetContent>{children}</RomaAuthSheetContent>
                </Sheet.Content>
            </Sheet.Panel>
        </Sheet>
    );
};
